import "./es.symbol.description-6025a604.js";
import "./es.function.bind-b4bdcd4b.js";
import "./es.array.from-fe752fa6.js";
import "./es.array.is-array-7a29277f.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.function.name-b230e7d4.js";
import "./es.date.to-string-6ed49878.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.regexp.to-string-e800d529.js";
import "./es.string.iterator-5de8a61e.js";
import { a as j } from "./index-5d0f31c6.js";
import "./web.set-timeout-72b6430f.js";
import { QUERIES as d, fpds as N } from "@ucl/shared-component-foundations";
import { useRef as Z, useMemo as oo, useState as $, useEffect as A } from "react";
import u from "styled-components";
import "./es.object.keys-9d66766f.js";
import { getAriaProps as to } from "./aria.js";
import "./es.array.concat-d1c9b847.js";
import "./es.array.map-d821aaf5.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as no } from "./getMetrics-953aa4f8.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { useWindowSize as eo } from "./useWindowSize.js";
import { Image as io } from "./image.js";
import { ModalWindow as ro, ModalHeader as lo, ModalBody as ao } from "./modalWindow.js";
import "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./index-8b07dec9.js";
import { jsxs as g, jsx as c } from "react/jsx-runtime";
import { ScreenReaderOnly as po } from "./screenReaderOnly.js";
import { useAccessibilityProps as T } from "./accessibility.js";
import "./export-cdcbfb2b.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./array-slice-79f93c56.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./iterate-13ada9e5.js";
import "./array-iteration-759bfbfa.js";
import "./function-apply-4756dee6.js";
import "./create-property-f9780ed1.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./an-instance-6efcfd6c.js";
import "./inherit-if-required-f068457b.js";
import "./set-species-5ede2ed0.js";
import "@ucl/shared-icons";
import "./es.array.filter-4e9c9996.js";
import "./es.object.entries-d2a19275.js";
import "./environment-ddee5959.js";
import "./validate-arguments-length-eb516e5b.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./array-method-is-strict-e5a3c878.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./es.array.join-c1bca812.js";
import "./aspectRatio.js";
import "./species-constructor-00346775.js";
import "./es.string.trim-6e13db75.js";
import "./string-trim-14e37ad3.js";
import "./mediaDisclosureButton.js";
import "./es.parse-int-d7709701.js";
import "react-dom";
import "./usePopoverIndex.js";
import "./useClient.js";
import "./disclosure.js";
import "./focusTrap.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.index-of-084b82ab.js";
import "./combineRefs-c9ad2c39.js";
import "./useOnClickOutside.js";
import "./closeButton.js";
import "./iconButton.js";
import "./button.js";
import "./index-55eee02a.js";
import "./tslib.es6-59e1c9d8.js";
import "./hooks_internal.js";
import "./analytics.js";
function co(o, t) {
  var e = typeof Symbol < "u" && o[Symbol.iterator] || o["@@iterator"];
  if (e)
    return (e = e.call(o)).next.bind(e);
  if (Array.isArray(o) || (e = uo(o)) || t && o && typeof o.length == "number") {
    e && (o = e);
    var a = 0;
    return function() {
      return a >= o.length ? { done: !0 } : { done: !1, value: o[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function uo(o, t) {
  if (o) {
    if (typeof o == "string")
      return k(o, t);
    var e = {}.toString.call(o).slice(8, -1);
    return e === "Object" && o.constructor && (e = o.constructor.name), e === "Map" || e === "Set" ? Array.from(o) : e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? k(o, t) : void 0;
  }
}
function k(o, t) {
  (t == null || t > o.length) && (t = o.length);
  for (var e = 0, a = Array(t); e < t; e++)
    a[e] = o[e];
  return a;
}
var ho = /* @__PURE__ */ u.div.withConfig({
  displayName: "photoGalleryLightbox__MainWrapper",
  componentId: "sc-1tauwxu-0"
})(["position:", ";display:", ";width:", ";flex-direction:", ";justify-content:", ";align-items:", ";align-self:", ";border-radius:", ";background:", ";gap:", ";"], function(o) {
  return o.theme.components.photoGalleryLightbox.MainWrapper.position;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.MainWrapper.display;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.MainWrapper.width;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.MainWrapper.flexDirection;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.MainWrapper.justifyContent;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.MainWrapper.alignItems;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.MainWrapper.alignSelf;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.MainWrapper.borderRadius;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.MainWrapper.background;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.MainWrapper.gap;
}), so = /* @__PURE__ */ u.div.withConfig({
  displayName: "photoGalleryLightbox__ImgWrapper",
  componentId: "sc-1tauwxu-1"
})(["position:", ";width:", ";background:", ";"], function(o) {
  return o.theme.components.photoGalleryLightbox.ImgWrapper.position;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.ImgWrapper.width;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.ImgWrapper.background;
}), mo = /* @__PURE__ */ u.div.withConfig({
  displayName: "photoGalleryLightbox__ContaintWrapper",
  componentId: "sc-1tauwxu-2"
})(["display:", ";padding:", ";flex-direction:", ";align-items:", ";align-self:", ";gap:", ";@media ", "{padding:", ";}"], function(o) {
  return o.theme.components.photoGalleryLightbox.ContaintWrapper.display;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.ContaintWrapper.padding;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.ContaintWrapper.flexDirection;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.ContaintWrapper.alignItems;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.ContaintWrapper.alignSelf;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.ContaintWrapper.gap;
}, d.tabletAndUp, function(o) {
  return o.theme.components.photoGalleryLightbox.ContaintWrapper.tabletAndUp.padding;
}), fo = /* @__PURE__ */ u.div.withConfig({
  displayName: "photoGalleryLightbox__TitleWrapper",
  componentId: "sc-1tauwxu-3"
})(["color:", ";font-family:", ";font-size:", ";font-style:", ";font-weight:", ";line-height:", ";"], function(o) {
  return o.theme.components.photoGalleryLightbox.TitleWrapper.color;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.TitleWrapper.fontFamily;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.TitleWrapper.fontSize;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.TitleWrapper.fontStyle;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.TitleWrapper.fontWeight;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.TitleWrapper.lineHeight;
}), go = /* @__PURE__ */ u.div.withConfig({
  displayName: "photoGalleryLightbox__DescriptionWrapper",
  componentId: "sc-1tauwxu-4"
})(["width:", ";font-family:", ";font-size:", ";font-style:", ";font-weight:", ";line-height:", ";color:", ";align-self:", ";overflow:", ";text-overflow:", ";"], function(o) {
  return o.theme.components.photoGalleryLightbox.DescriptionWrapper.width;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.DescriptionWrapper.fontFamily;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.DescriptionWrapper.fontSize;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.DescriptionWrapper.fontStyle;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.DescriptionWrapper.fontWeight;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.DescriptionWrapper.lineHeight;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.DescriptionWrapper.color;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.DescriptionWrapper.alignSelf;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.DescriptionWrapper.overflow;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.DescriptionWrapper.textOverflow;
}), bo = /* @__PURE__ */ u.div.withConfig({
  displayName: "photoGalleryLightbox__ImageCount",
  componentId: "sc-1tauwxu-5"
})(["display:", ";width:", ";align-items:", ";justify-content:", ";"], function(o) {
  return o.theme.components.photoGalleryLightbox.ImageCount.display;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.ImageCount.width;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.ImageCount.alignItems;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.ImageCount.justifyContent;
}), O = /* @__PURE__ */ u.button.withConfig({
  displayName: "photoGalleryLightbox__NavButton",
  componentId: "sc-1tauwxu-6"
})(["position:", ";z-index:", ";top:", ";", " height:", ";width:", ";display:", ";align-items:", ";justify-content:", ";border:", ";border-radius:", ";cursor:", ";background-color:", ";color:", ";&:not(&--disabled):focus-visible{outline:", ";outline-offset:", ";}&:disabled{cursor:", ";color:", ";}&:hover:not(&--disabled){background-color:", ";color:", ";}@media ", "{display:", ";}"], function(o) {
  return o.theme.components.photoGalleryLightbox.NavButton.position;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.NavButton.zIndex;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.NavButton.top;
}, function(o) {
  return o.$flag === "left" ? o.theme.components.photoGalleryLightbox.NavButton.flag.left : o.theme.components.photoGalleryLightbox.NavButton.flag.default;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.NavButton.height;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.NavButton.width;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.NavButton.display;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.NavButton.alignItems;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.NavButton.justifyContent;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.NavButton.border;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.NavButton.borderRadius;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.NavButton.cursor;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.NavButton.backgroundColor;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.NavButton.color;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.NavButton.focusVisible.outline;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.NavButton.focusVisible.outlineOffset;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.NavButton.disabled.cursor;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.NavButton.disabled.color;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.NavButton.hover.backgroundColor;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.NavButton.hover.color;
}, d.mobile, function(o) {
  return o.theme.components.photoGalleryLightbox.NavButton.mobile.display;
}), yo = /* @__PURE__ */ u(ro).withConfig({
  displayName: "photoGalleryLightbox__PhotoLightboxModelWindow",
  componentId: "sc-1tauwxu-7"
})(["box-shadow:", "!important;.ModalWindow__content{--modal-content-padding-block:0px;--modal-content-max-height:100dvh;padding:", " !important;}.ModalWindow__body{max-height:", ";}@media ", "{.ModalWindow__content{--modal-content-padding-block:", ";--modal-content-max-height:92dvh;padding:", " !important;&--fullPage{--modal-content-padding-block:", ";--modal-content-max-height:100dvh;}}}@media ", "{border-radius:", "!important;min-width:", "!important;height:", " !important;.ModalWindow__content{gap:", " !important;}.ModalWindow__body{margin:0;padding:0;}}"], function(o) {
  return o.theme.components.photoGalleryLightbox.PhotoLightboxModalWindow.boxShadow;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.PhotoLightboxModalWindow.padding;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.PhotoLightboxModalWindow.modalWindowBody.maxHeight;
}, d.tabletAndUp, N.semantic.space["8x"], function(o) {
  return o.theme.components.photoGalleryLightbox.PhotoLightboxModalWindow.tabletAndUp.padding;
}, N.semantic.space["8x"], d.mobile, function(o) {
  return o.theme.components.photoGalleryLightbox.PhotoLightboxModalWindow.mobile.borderRadius;
}, function(o) {
  return o.theme.components.photoGalleryLightbox.PhotoLightboxModalWindow.mobile.minWidth;
}, function(o) {
  var t = o.$hasContentInImages;
  return t ? "100%" : "auto";
}, function(o) {
  return o.theme.components.photoGalleryLightbox.PhotoLightboxModalWindow.mobile.gap;
}), vo = /* @__PURE__ */ u.div.withConfig({
  displayName: "photoGalleryLightbox__Disclosures",
  componentId: "sc-1tauwxu-8"
})(["font-size:", ";font-family:", ";font-weight:", ";line-height:", ";color:", ";padding-top:", ";"], function(o) {
  var t;
  return o == null || (t = o.theme) == null || (t = t.components) == null || (t = t.photoGalleryLightbox) == null || (t = t.Disclosures) == null ? void 0 : t.fontSize;
}, function(o) {
  var t;
  return o == null || (t = o.theme) == null || (t = t.components) == null || (t = t.photoGalleryLightbox) == null || (t = t.Disclosures) == null ? void 0 : t.fontFamily;
}, function(o) {
  var t;
  return o == null || (t = o.theme) == null || (t = t.components) == null || (t = t.photoGalleryLightbox) == null || (t = t.Disclosures) == null ? void 0 : t.fontWeight;
}, function(o) {
  var t;
  return o == null || (t = o.theme) == null || (t = t.components) == null || (t = t.photoGalleryLightbox) == null || (t = t.Disclosures) == null ? void 0 : t.lineHeight;
}, function(o) {
  var t;
  return o == null || (t = o.theme) == null || (t = t.components) == null || (t = t.photoGalleryLightbox) == null || (t = t.Disclosures) == null ? void 0 : t.color;
}, function(o) {
  var t;
  return o == null || (t = o.theme) == null || (t = t.components) == null || (t = t.photoGalleryLightbox) == null || (t = t.Disclosures) == null ? void 0 : t.paddingTop;
}), xo = /* @__PURE__ */ u(lo).withConfig({
  displayName: "photoGalleryLightbox__StyledModalHeader",
  componentId: "sc-1tauwxu-9"
})(["@media ", "{padding:", ";}"], d.mobile, function(o) {
  var t;
  return o == null || (t = o.theme) == null || (t = t.components) == null || (t = t.photoGalleryLightbox) == null ? void 0 : t.StyledModalHeader.mobile.padding;
});
function Lo(o) {
  for (var t = co(o), e; !(e = t()).done; ) {
    var a = e.value;
    if (a.title || a.description || a.disclosureContent)
      return !0;
  }
  return !1;
}
function un(o) {
  var t = o.images, e = t === void 0 ? [] : t, a = o.onClose, F = o.className, z = o.autoImageChange, b = o.isOpen, G = o.imageInterval, H = G === void 0 ? 3e3 : G, W = o.activeIndex, y = W === void 0 ? 1 : W, w = o.accessibilityOptions, f = w === void 0 ? {} : w, _ = o.separator, M = _ === void 0 ? "of" : _, B = o.variant, E = B === void 0 ? "large" : B, R = no({
    label: "PhotoGalleryLightbox"
  }), s = Z(null), P = eo(), C = P.width, S = oo(function() {
    return Lo(e);
  }, []), I = $(y), p = I[0], m = I[1], D = $({
    id: 1,
    src: "",
    alt: "",
    title: "",
    description: "",
    disclosureContent: "",
    objectFit: "cover",
    ratio: "16/9"
  }), l = D[0], v = D[1], U = f.prevButton, K = f.nextButton, X = f.closeButton, V = f.modal, q = T("button", Object.assign({
    ariaLabel: "previous"
  }, U)), Q = T("button", Object.assign({
    ariaLabel: "next"
  }, K)), h = e == null ? void 0 : e.length, x = function() {
    if (p >= 1) {
      var i = p === 1 ? h : p - 1, n = e[i - 1];
      v({
        id: (n == null ? void 0 : n.id) || i,
        src: (n == null ? void 0 : n.src) || "",
        alt: (n == null ? void 0 : n.alt) || "",
        title: (n == null ? void 0 : n.title) || "",
        description: (n == null ? void 0 : n.description) || "",
        disclosureContent: (n == null ? void 0 : n.disclosureContent) || "",
        objectFit: (n == null ? void 0 : n.objectFit) || "cover",
        ratio: (n == null ? void 0 : n.ratio) || "16/9"
      }), m(i);
    }
  }, L = function() {
    if (p <= h) {
      var i = p === h ? 1 : p + 1, n = e[i - 1];
      v({
        id: (n == null ? void 0 : n.id) || i,
        src: (n == null ? void 0 : n.src) || "",
        alt: (n == null ? void 0 : n.alt) || "",
        title: (n == null ? void 0 : n.title) || "",
        description: (n == null ? void 0 : n.description) || "",
        disclosureContent: (n == null ? void 0 : n.disclosureContent) || "",
        objectFit: (n == null ? void 0 : n.objectFit) || "cover",
        ratio: (n == null ? void 0 : n.ratio) || "16/9"
      }), m(i);
    }
  }, J = function(i) {
    C > 599 || (s.current = i.touches[0].clientX);
  }, Y = function(i) {
    s.current !== null && (C > 599 || ((s == null ? void 0 : s.current) - i.changedTouches[0].clientX > 50 ? L() : i.changedTouches[0].clientX - (s == null ? void 0 : s.current) > 50 && x()));
  };
  return A(function() {
    var r = e[p - 1];
    if (v({
      id: (r == null ? void 0 : r.id) || p,
      src: (r == null ? void 0 : r.src) || "",
      alt: (r == null ? void 0 : r.alt) || "",
      title: (r == null ? void 0 : r.title) || "",
      description: (r == null ? void 0 : r.description) || "",
      disclosureContent: (r == null ? void 0 : r.disclosureContent) || "",
      objectFit: (r == null ? void 0 : r.objectFit) || "cover",
      ratio: (r == null ? void 0 : r.ratio) || "16/9"
    }), z && b) {
      if (p <= h) {
        var i = setInterval(function() {
          var n = p % h + 1;
          m(n);
        }, H);
        return function() {
          return clearInterval(i);
        };
      }
      m(1);
    }
  }, [p, b]), A(function() {
    m(y);
  }, [y]), (e == null ? void 0 : e.length) > 0 ? /* @__PURE__ */ g(yo, Object.assign({
    "data-wrapper": "PhotoLightboxModelWindow",
    variant: E,
    isOpen: b,
    onClose: function() {
      var i;
      return a == null ? void 0 : a((i = l == null ? void 0 : l.id) != null ? i : 1);
    },
    bgOverlayColor: "rgba(0, 20, 46, 0.30)",
    $hasContentInImages: S
  }, to("div", V), R, {
    children: [/* @__PURE__ */ c(xo, {
      hasClose: !0,
      onClose: function() {
        var i;
        return a == null ? void 0 : a((i = l == null ? void 0 : l.id) != null ? i : 1);
      },
      accessibilityOptions: X
    }), /* @__PURE__ */ c(ao, {
      children: /* @__PURE__ */ g(ho, {
        className: F,
        children: [/* @__PURE__ */ g(so, {
          children: [/* @__PURE__ */ c(O, Object.assign({
            tabIndex: 0,
            onClick: x
          }, q, {
            onKeyDown: function(i) {
              (i.code === "Enter" || i.code === "Space") && (i.preventDefault(), x());
            },
            $flag: "left",
            children: /* @__PURE__ */ c(j, {
              icon: "caretLeft"
            })
          })), /* @__PURE__ */ c(io, {
            src: l == null ? void 0 : l.src,
            alt: l == null ? void 0 : l.alt,
            onTouchStart: J,
            onTouchEnd: Y,
            ratio: l == null ? void 0 : l.ratio,
            objectFit: l == null ? void 0 : l.objectFit
          }), /* @__PURE__ */ c(O, Object.assign({
            tabIndex: 0,
            onClick: L,
            onKeyDown: function(i) {
              (i.code === "Enter" || i.code === "Space") && (i.preventDefault(), L());
            }
          }, Q, {
            $flag: "right",
            children: /* @__PURE__ */ c(j, {
              icon: "caretRight"
            })
          }))]
        }), /* @__PURE__ */ c(po, {
          "aria-live": "assertive",
          children: p + " " + M + " " + h + " " + (l == null ? void 0 : l.alt)
        }), /* @__PURE__ */ c(bo, {
          style: {
            alignItems: "center"
          },
          children: p + " " + M + " " + h
        }), S && /* @__PURE__ */ g(mo, {
          children: [/* @__PURE__ */ c(fo, {
            children: l == null ? void 0 : l.title
          }), /* @__PURE__ */ c(go, {
            children: l == null ? void 0 : l.description
          }), /* @__PURE__ */ c(vo, {
            children: l == null ? void 0 : l.disclosureContent
          })]
        })]
      })
    })]
  })) : null;
}
export {
  un as PhotoGalleryLightbox
};
